// extracted by mini-css-extract-plugin
export default {"bannerContainer":"serviceWorkerAlert_bannerContainer__sRMAN","hidden":"serviceWorkerAlert_hidden__eN0cc","banner":"serviceWorkerAlert_banner__8u+DD"};